export default __webpack_public_path__ + "static/media/kris.3e29677d.webp";